import ToolTip from "components/design/toolTip";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { Info } from "components/icons/Info";
import {
  WITHHOLDING_STATUS,
  WITHHOLDING_STATUS_LABEL,
  withholdingStatusType,
} from "constants/vendorBills";

export const WithholdingStatusTag = ({
  status,
}: {
  status: withholdingStatusType;
}) => {
  if (status === WITHHOLDING_STATUS.PAID_TO_IRS) {
    return (
      <Tag tagType="green" rounded icon={false}>
        {WITHHOLDING_STATUS_LABEL[status]}
      </Tag>
    );
  }

  const tooltipText =
    "This amount was withheld from the vendor payment and will be reported to the IRS on Form 1042.";

  return (
    <span className="t-inline-flex t-items-center t-gap-1 t-rounded-full t-bg-blue-10 t-px-1.5 t-py-0.5 t-text-body-sm t-text-blue-70">
      {WITHHOLDING_STATUS_LABEL[status]}
      <ToolTip text={tooltipText}>
        <span className="t-flex t-items-center">
          <Info size="12" />
        </span>
      </ToolTip>
    </span>
  );
};
